module.exports = __webpack_public_path__ + "assets/img/home-zggs-light.caf04613.png";